import { useIntl } from 'react-intl';
import BlockDataForm from '@plone/volto/components/manage/Form/BlockDataForm';
import SidebarPortal from '@plone/volto/components/manage/Sidebar/SidebarPortal';
import CountdownSchema from './schema';
import CountdownView from './CountdownView';
import type { CountdownData } from './CountdownView';

type CountdownEditProps = {
  data: CountdownData;
  block: string;
  selected: boolean;
  onChangeBlock: (block: string, data: CountdownData) => void;
};

const CountdownEdit = (props: CountdownEditProps) => {
  const { data, block, onChangeBlock, selected } = props;
  const intl = useIntl();
  const schema = CountdownSchema({ intl });

  return (
    <>
      <CountdownView data={data} />
      <SidebarPortal selected={selected}>
        <BlockDataForm
          schema={schema}
          title={schema.title}
          onChangeField={(id: string, value: unknown) => {
            onChangeBlock(block, { ...data, [id]: value });
          }}
          formData={data}
          block={block}
        />
      </SidebarPortal>
    </>
  );
};

export default CountdownEdit;
